'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    top: ', ';\n    left: ', ';\n    background: ', ';\n    width: ', ';\n    height: ', ';\n    display: block;\n    -webkit-clip: auto;\n    clip: auto;\n    position: relative;\n    transition : all 1s;\n    border-radius: 50%;\n    z-index : 2147483647;\n'], ['\n    top: ', ';\n    left: ', ';\n    background: ', ';\n    width: ', ';\n    height: ', ';\n    display: block;\n    -webkit-clip: auto;\n    clip: auto;\n    position: relative;\n    transition : all 1s;\n    border-radius: 50%;\n    z-index : 2147483647;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DoughnutWrapper = _styledComponents2.default.div(_templateObject, function (props) {
    return props.setpos ? props.setpos + 'px' : '40px';
}, function (props) {
    return props.setpos ? props.setpos + 'px' : '40px';
}, function (props) {
    return props.wrapperTransparency ? props.wrapperTransparency : 'white';
}, function (props) {
    return props.donutwidth ? props.donutwidth + 'px' : '220px';
}, function (props) {
    return props.donutwidth ? props.donutwidth + 'px' : '220px';
});

exports.default = DoughnutWrapper;